// extracted by mini-css-extract-plugin
export default {"modeSwitcher":"TextSwitch_modeSwitcher__hB8cA","option":"TextSwitch_option__PLGhM","active":"TextSwitch_active__HrXjs"};